import(/* webpackMode: "eager" */ "/tmp/jenkins-f72f010e/workspace/genesis_main/apps/site/app/(main)/[country]/[language]/(fullLayout)/error.tsx")